import { AdvancedSelect } from 'components/AdvancedSelect'
import { getAccessToken } from 'helpers/getAccessToken'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

export function RecursoEducativoMultiSelect(props) {
    const [recursos, setRecursos] = useState([{ id: 1, descripcion: 'Foo' }])

    useEffect(() => {
        const load = async () => {
            try {
                const token = getAccessToken()
                const response = await fetch(`${process.env.REACT_APP_API_URL}/clase/recursos-educativos`, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                const data = await response.json()
                if (response.ok) {
                    setRecursos(data)
                } else {
                    toast.error('Ocurrió un error al obtener los recursos educativos')
                }
            } catch (error) {
                toast.error('Ocurrió un error en el servidor')
            }
        }
        load()
    }, [])

    return <AdvancedSelect optionValue='id' optionLabel='descripcion' {...props} options={recursos} />
}
